import { useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PublicUserMenu() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);
  const rootRef = useRef(null);

  const displayName = useMemo(() => {
    return (user?.fullName || user?.name || user?.email || 'User').trim();
  }, [user]);

  const profilePhotoUrl = useMemo(() => {
    return (
      user?.profilePhotoUrl ||
      user?.profile_photo_url ||
      user?.profile_photo ||
      user?.photo_url ||
      user?.avatar_url ||
      ''
    );
  }, [user]);

  const showProfilePhoto = Boolean(profilePhotoUrl) && !imageFailed;

  const dashboardPath = user?.role === 'admin' ? '/dashboard/admin' : '/dashboard/member';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    setImageFailed(false);
  }, [profilePhotoUrl]);

  return (
    <div className="public-user-menu" ref={rootRef}>
      <button
        type="button"
        className="user-menu-trigger"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-haspopup="menu"
      >
        {showProfilePhoto ? (
          <img
            className="user-avatar-image"
            src={profilePhotoUrl}
            alt={displayName}
            onError={() => setImageFailed(true)}
          />
        ) : (
          <span className="user-avatar-name" title={displayName}>
            {displayName}
          </span>
        )}
      </button>

      {open && (
        <div className="user-menu-dropdown" role="menu">
          <Link to={dashboardPath} onClick={() => setOpen(false)} role="menuitem">
            Dashboard
          </Link>
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              logout();
            }}
            role="menuitem"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
}
